const toDisplayString = value =>
  typeof value === 'string' && value.trim() ? value : null;

export default class CustomError extends Error {
  constructor({
    code,
    codeName,
    error,
    message,
    icon,
    title,
    technicalMessage,
    description,
    button,
    transactionId,
    endpoint
  }) {
    super(codeName);
    this.code = code || 1;
    this.codeName = codeName;
    this.title =
      toDisplayString(error?.client?.title?.['en-US']) ??
      toDisplayString(title);
    this.message =
      toDisplayString(error?.client?.message?.['en-US']) ??
      toDisplayString(message);
    this.description =
      toDisplayString(error?.client?.description?.['en-US']) ??
      toDisplayString(description);
    this.technicalMessage =
      toDisplayString(error?.technicalMessage) ??
      toDisplayString(technicalMessage);
    this.transactionId = transactionId;
    this.endpoint = endpoint || null;
    this.isCustomError = true;
    this.icon = icon || null;
    this.button = button || null;
  }
  serialize() {
    return {
      code: this.code,
      codeName: this.codeName,
      title: this.title,
      message: this.message,
      description: this.description,
      technicalMessage: this.technicalMessage,
      isCustomError: this.isCustomError,
      transactionId: this.transactionId,
      endpoint: this.endpoint,
      icon: this.icon,
      button: this.button
    };
  }
}
